export default __webpack_public_path__ + "static/media/loading.cd6dc6b3.gif";